 
<template>
  <div class="h-screen flex w-full bg-img" >
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
    >
      <img v-if="mounted" src="@/assets/images/pages/graphic-5.png" alt="graphic-404" class="mx-auto mb-4 max-w-full" />
      <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">{{ $route.query.title }}</h1>
      <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-text-inverse">{{ $route.query.message }}</p>
      <vs-button size="large" to="/pages/login">Go To Login Page</vs-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mounted: false,
      logo2: ""
    };
  },
  computed: {
    logo() {
      console.log("logo:","@/assets/images/pages/" + this.$route.query.logo);
      return "@/assets/images/pages/" + this.$route.query.logo;
    }
  },
  methods:{
    myLogo(){
      return "";
    }
  },
  mounted() {
    
    this.mounted = true;
  },
  created() {
    this.mounted = false;
     this.logo2 = "@/assets/images/pages/maintenance.png";
    console.log("this.logo2:", this.logo2);
    console.log("params:", this.$route.query);
  }
};
</script>